export default __webpack_public_path__ + "d5518b8c07f4243657a89fd06c8d7998.svg";